import { render, staticRenderFns } from "./TreatmentMatrix.vue?vue&type=template&id=9eb06810&scoped=true"
import script from "./TreatmentMatrix.vue?vue&type=script&lang=js"
export * from "./TreatmentMatrix.vue?vue&type=script&lang=js"
import style0 from "./TreatmentMatrix.vue?vue&type=style&index=0&id=9eb06810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb06810",
  null
  
)

export default component.exports